import { StrictMode } from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { SWRConfig } from "swr";
import { bootTheme } from "@branding/ui";
import { App } from "./App";
import { SsrDataContext, readBrowserSsrData } from "./lib/ssr-data";
import "./styles.css";

bootTheme();

const root = document.getElementById("root");
if (!root) throw new Error("root missing");

const ssrData = readBrowserSsrData();

const tree = (
  <StrictMode>
    <SWRConfig value={{ revalidateOnFocus: false }}>
      <SsrDataContext.Provider value={ssrData}>
        <BrowserRouter basename="/pasar">
          <App />
        </BrowserRouter>
      </SsrDataContext.Provider>
    </SWRConfig>
  </StrictMode>
);

if (root.hasChildNodes()) {
  hydrateRoot(root, tree);
} else {
  createRoot(root).render(tree);
}
